module.exports = __webpack_public_path__ + "20e3462f469f5ad7aeec6ea281346a46.pdf";